import { render } from "./Imo1Component.vue?vue&type=template&id=4d0ea7fe"
import script from "./Imo1Component.vue?vue&type=script&lang=js"
export * from "./Imo1Component.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__